import type { RumEvent } from "@datadog/browser-rum";

/**
 * Hung third-party tracker connections keep RUM actions open and inflate their
 * `loading_time`. The URL list ignores those origins; `isInflatedActionEvent`
 * drops what the list can't catch. Keep in sync with pro-web's
 * `datadog-activity-exclusions.util.ts`.
 */

export const DATADOG_EXCLUDED_ACTIVITY_URLS: RegExp[] = [
  /clientstream\.launchdarkly\.com/,
  /events\.launchdarkly\.com/,
  /clarity\.ms/,
  /data\.pendo\.io/,
  /facebook\.(com|net)/,
  /linkedin\.com|licdn\.com/,
  /doubleclick\.net/,
  /googleads\.|googlesyndication\.com|google-analytics\.com|googletagmanager\.com/,
  /bing\.com/,
  /churnzero\.net/,
  /forethought\.ai/,
];

/** 60 seconds in nanoseconds. */
export const ACTION_LOADING_TIME_ARTIFACT_THRESHOLD_NS = 60_000_000_000;

export function isInflatedActionEvent(
  event: RumEvent | null | undefined,
): boolean {
  if (event?.type !== "action") {
    return false;
  }

  return (
    (event.action?.loading_time ?? 0) >
    ACTION_LOADING_TIME_ARTIFACT_THRESHOLD_NS
  );
}
